/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"

const DeleteModal = ({ open, user, isSubmit, handleDelete, onClose }) => {
  return (
    <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete {user}?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmit}
          loadingPosition="start"
          startIcon={<SaveIcon />}
          color="error"
          variant="contained"
          onClick={handleDelete}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteModal
